import {
    IProps,
} from './types';

import React, {
    ChangeEvent,
    FC,
} from 'react';

import {
    OPTIONS,
} from './constants';

import styles from './PageSizeSelect.module.scss';

const PageSizeSelect: FC<IProps> = (props) => {
    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const value = Number(event.target.value);

        if (value === props.take) {
            return;
        }

        props.onChangeValue(value);
    };

    return (
        <div
            className={styles.pageSizeSelect}
        >
            <select
                className={styles.select}
                value={props.take}
                onChange={handleChange}
            >
                {OPTIONS.map((size) => (
                    <option key={size} value={size}>
                        {size}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default PageSizeSelect;
